<template>
  <VRegisterApp name="confirmation" @mounted="handleMounted" @next="handleNext">
    <!-- <template #header v-if="current&&paid">{{ current.Title }}</template> -->
    <div class="confirmation-body">
      <template v-if="loading">
        <div class="qr" v-loading="true" :element-loading-text="$t('registration.confirmation.loading')" :element-loading-spinner="svg" element-loading-svg-view-box="0, 0, 100, 100"></div>
        <!-- <div>
          <el-button type="primary" @click="fetchData">{{ $t('registration.confirmation.refresh') }}</el-button>
        </div> -->
      </template>
      <template v-else>
        <article style="width: 100%; padding: 12px" ref="imageWrapper" v-html="html"></article>
        <div class="tools">
          <!-- <el-button v-if="paid" type="primary" @click="handleSendAgain">{{ $t('registration.confirmation.send-confirm') }}</el-button>
           -->
          <el-button v-if="paid" type="primary" @click="handleSaveImage">{{ $t('registration.confirmation.save-image') }}</el-button>

          <el-button v-if="paid && $event.Config.Invoice" type="primary" @click="$router.push({ name: 'personalcenter-order' })">{{ $t('registration.confirmation.invoice') }}</el-button>

          <el-button  v-if="!($event?.Config?.HideBuyAgain===true)" type="primary" @click="$router.push({ name: 'ticket' })">{{ $t('registration.confirmation.buy-again') }}</el-button>
          <el-button type="primary" @click="handleHome">{{ $t('registration.confirmation.back-login') }}</el-button>
        </div>
      </template>
    </div>
  </VRegisterApp>
</template>

<script setup>
  import VRegisterApp from '../app/index.vue'
  import { ElLoading } from 'element-plus'

  import { confirmation, getConfirmation, getReceipt } from '@/api/registration'
  import { onMounted, ref, inject, computed } from 'vue'
  import { ArrowDown, ArrowUp } from '@element-plus/icons-vue'
  import html2canvas from 'html2canvas'
  import { useRouter } from 'vue-router'
  import { useAppStore } from '@/store/modules/app'
  import {useUserStore} from '@/store/modules/user'
  //
  const { event } = useAppStore()
  const { logout } = useUserStore()
  const router = useRouter()

  const handleHome = () => {
    let e = event
    if (e.Config.HideIndex && e.Steps && ((e.Steps.length > 0 && e.Steps[0] == 'personal') || (e.Steps.length > 1 && e.Steps[0] == 'login' && e.Steps[1] == 'personal'))) {
      logout();
      router.push({ name: 'personal', query: { uid: '', v: e.ID } })
    } else {
      router.push({ name: 'index', query: { uid: '', v: e.ID } })
    }
  }

  const form = ref({
    confirmation: '0',
  })
  const html = ref('')
  const pageConfig = ref({})

  const $steps = inject('$steps')
  const $event = inject('$event')

  const imageWrapper = ref(null)
  const current = computed(() => {
    for (var g of $steps.value) {
      if (g.Name == 'confirmation') {
        return g
      }
    }
    return null
  })

  const loading = ref(true)

  const svg = `<circle cx="75" cy="50" fill="#ffffff" r="8">
  <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.9s"></animate>
  <animate attributeName="fill" values="#ffffff;#ffffff;#eeeeee;#ffffff;#ffffff" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.9s"></animate>
</circle><circle cx="70.22542485937369" cy="64.69463130731182" fill="#ffffff" r="8">
  <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.8s"></animate>
  <animate attributeName="fill" values="#ffffff;#ffffff;#eeeeee;#ffffff;#ffffff" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.8s"></animate>
</circle><circle cx="57.72542485937369" cy="73.77641290737884" fill="#ffffff" r="8">
  <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.7s"></animate>
  <animate attributeName="fill" values="#ffffff;#ffffff;#eeeeee;#ffffff;#ffffff" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.7s"></animate>
</circle><circle cx="42.27457514062632" cy="73.77641290737884" fill="#ffffff" r="8">
  <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.6s"></animate>
  <animate attributeName="fill" values="#ffffff;#ffffff;#eeeeee;#ffffff;#ffffff" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.6s"></animate>
</circle><circle cx="29.774575140626318" cy="64.69463130731182" fill="#ffffff" r="8">
  <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate>
  <animate attributeName="fill" values="#ffffff;#ffffff;#eeeeee;#ffffff;#ffffff" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5s"></animate>
</circle><circle cx="25" cy="50" fill="#ffffff" r="8">
  <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.4s"></animate>
  <animate attributeName="fill" values="#ffffff;#ffffff;#eeeeee;#ffffff;#ffffff" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.4s"></animate>
</circle><circle cx="29.77457514062631" cy="35.30536869268818" fill="#ffffff" r="8">
  <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.3s"></animate>
  <animate attributeName="fill" values="#ffffff;#ffffff;#eeeeee;#ffffff;#ffffff" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.3s"></animate>
</circle><circle cx="42.27457514062631" cy="26.223587092621162" fill="#ffffff" r="8">
  <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.2s"></animate>
  <animate attributeName="fill" values="#ffffff;#ffffff;#eeeeee;#ffffff;#ffffff" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.2s"></animate>
</circle><circle cx="57.72542485937368" cy="26.22358709262116" fill="#ffffff" r="8">
  <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.1s"></animate>
  <animate attributeName="fill" values="#ffffff;#ffffff;#eeeeee;#ffffff;#ffffff" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.1s"></animate>
</circle><circle cx="70.22542485937367" cy="35.30536869268816" fill="#ffffff" r="8">
  <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="0s"></animate>
  <animate attributeName="fill" values="#ffffff;#ffffff;#eeeeee;#ffffff;#ffffff" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="0s"></animate>
</circle>`

  const handleMounted = async (val) => {
    pageConfig.value = val.pageConfig
    await fetchData()
  }
  const paid = ref(false)
  const fetchData = async () => {
    loading.value = true
    const { ret, data } = await confirmation()
    if (ret === 0) {
      loading.value = false
      html.value = data.confirmation
      paid.value = data.paid
    }
    //
  }

  const handleSendAgain = async () => {
    const loadingInstance = ElLoading.service({ fullscreen: true })
    const { ret, data } = await confirmation({ action: 'sent' })
    if (ret === 0) {
      loadingInstance.close()
    }
  }

  const handleReceipt = async () => {
    const loadingInstance = ElLoading.service({ fullscreen: true })
    try {
      await getReceipt()
    } catch (e) {}
    loadingInstance.close()
  }

  const handleSaveImage = () => {
    const clientWidth = imageWrapper.value.offsetWidth
    const clientHeight = imageWrapper.value.offsetHeight
    const kh = [clientWidth, clientHeight]

    html2canvas(imageWrapper.value, { useCORS: true, logging: true }).then((cvs) => {
      const dataURL = cvs.toDataURL('image/png')
      let canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const img = new Image()
      img.crossOrigin = 'Anonymous' // 允许跨域
      img.src = dataURL
      img.onload = () => {
        canvas.height = kh[1]
        canvas.width = kh[0]
        ctx.drawImage(img, 0, 0, kh[0], kh[1])
        const dataURL = canvas.toDataURL('image/png')
        canvas = null
        const link = document.createElement('a')
        link.href = dataURL
        link.download = `${$event.EventName}.png`
        link.click()
      }
    })
  }
</script>

<style lang="scss" scoped>
  .confirmation-header {
    display: flex;
    justify-content: center;
    .el-radio-group {
      :deep() {
        .el-radio__input {
          display: none;
        }
        .el-radio {
          margin-right: 12px;
          background: #f8f9fa;
          border: 1px solid #dadfe3;
          border-radius: 4px;
          color: #363f5e;
          &.is-checked {
            border-color: var(--el-color-primary);
            color: var(--el-color-primary);
          }
        }
      }
    }
  }
  .confirmation-body {
    margin: 30px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    .title {
      font-weight: bold;
      font-size: 18px;
      line-height: 25px;
      color: #363f5e;
      margin-top: 0;
    }
    .qr {
      margin: 24px 0 24px 0;
      width: 200px;
      height: 200px;
      border-radius: 12px;
      overflow: hidden;
      background-color: #000;
      padding: 7px;
      background: #f1f4f9;
      border-radius: 16px;
      box-sizing: border-box;
      :deep() {
        .el-loading-mask {
          background: rgba(53, 59, 85, 0.75);
        }
        .el-loading-spinner {
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin-top: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          svg {
            width: 80px;
            height: 80px;
            animation: none;
          }
          .el-loading-text {
            color: #fff;
            padding: 0px 24px;
          }
        }
      }
      img {
        width: 100%;
        height: 100%;
        border-radius: 16px;
      }
    }
  }
  .tools {
    margin: 24px 0px;
    white-space: nowrap;
    .el-button {
      padding: 0 3px;
    }
    .el-button + .el-button {
      margin-left: 6px;
    }
  }
</style>
